import React from "react";
import ReactDOM from "react-dom";
// Component Files
import App from "./App"

//Stylesheet
import "./index.css"


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);